module.exports = __webpack_public_path__ + "img/credit-one-bank-club-logo.71b809d5.png";